import { render, staticRenderFns } from "./ArticleClassCreate.vue?vue&type=template&id=52d44bc1&scoped=true"
import script from "./ArticleClassCreate.vue?vue&type=script&lang=js"
export * from "./ArticleClassCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d44bc1",
  null
  
)

export default component.exports